import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-apartment-one',
  templateUrl: './apartment-one.component.html',
  styleUrls: ['./apartment-one.component.css']
})
export class ApartmentOneComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    window.scroll(0, -window.scrollY);
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/apartment-one/apartment-one.component.ts